import { Example } from "./Example";
import { useTranslation } from "react-i18next";

import { AccessSummary } from "../../api";
import styles from "./Example.module.css";

// Area each example question belongs to: "documentation" or an App name from ehb_apps.json.
const EXAMPLE_AREAS = ["documentation", "documentation", "ETV", "ETV", "ETV", "ETV"];

interface Props {
    onExampleClicked: (value: string) => void;
    useMultimodalAnswering?: boolean;
    access?: AccessSummary;
}

export const ExampleList = ({ onExampleClicked, useMultimodalAnswering, access }: Props) => {
    const { t } = useTranslation();

    const DEFAULT_EXAMPLES: string[] = [
        t("defaultExamples.1"),
        t("defaultExamples.2"),
        t("defaultExamples.3"),
        t("defaultExamples.4"),
        t("defaultExamples.5"),
        t("defaultExamples.6")
    ];
    const MULTIMODAL_EXAMPLES: string[] = [
        t("multimodalExamples.1"),
        t("multimodalExamples.2"),
        t("multimodalExamples.3"),
        t("multimodalExamples.4"),
        t("multimodalExamples.5"),
        t("multimodalExamples.6")
    ];

    const examples = (useMultimodalAnswering ? MULTIMODAL_EXAMPLES : DEFAULT_EXAMPLES).filter((_, i) => {
        const area = EXAMPLE_AREAS[i];
        return area === "documentation" ? !!access?.documentation : !!access?.apps.includes(area);
    });

    return (
        <ul className={styles.examplesNavList}>
            {examples.map((question, i) => (
                <li key={i}>
                    <Example text={question} value={question} onClick={onExampleClicked} />
                </li>
            ))}
        </ul>
    );
};
